'use client';

import React from 'react';
import clsx from 'clsx';
import appConfig from '@/utils/appConfig';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

type VerticalPosition = 'top' | 'bottom';
type HorizontalPosition = 'left' | 'right';

interface RibbonProps {
    text: string;
    position?: {
        vertical: VerticalPosition;
        horizontal: HorizontalPosition;
    };
}

const Ribbon = ({
    text,
    position = { vertical: 'top', horizontal: 'left' },
}: RibbonProps) => {
    const pathname = usePathname();

    const ribbonClasses = clsx(
        `${appConfig.colors.buttonPrimary}`,
        'font-semibold',
        'py-1',
        `${position.vertical === 'top' ? 'top-0 xl:top-0' : 'xl:bottom-0'}`,
        `${position.horizontal === 'left' ? 'xl:left-0' : 'xl:right-0'}`,
        'text-white',
        'text-center',
        'text-xl',
        'shadow-outline',
        'w-full',
        'absolute',
        'p-8',
        'inset-0'
    );

    const ribbonContainerClasses = clsx(
        'z-20',
        'block',
        'xl:fixed',
        'xl:-left-[105px]',
        'top-0',
        'xl:top-[30%]',
        'w-full',
        'xl:w-[250px]',
        'h-[40px]',
        'transform',
        'rotate-0',
        'xl:rotate-[-90deg]',
        'left-0',
        'relative',
        'drop-shadow-none',
        'xl:drop-shadow-xl'
    );

    if (pathname === '/quote' || pathname === '/flexi-lease') {
        return null;
    }

    return (
        <div className={ribbonContainerClasses}>
            <Link href="/quote" className={ribbonClasses}>
                {text}
            </Link>
        </div>
    );
};

export default Ribbon;
